module.exports = __webpack_public_path__ + "static/media/flexibility.3345852d.svg";